// extracted by mini-css-extract-plugin
module.exports = {"controls":"Carousel_controls___3D1e","root":"Carousel_root__By4Fm","slide":"Carousel_slide__MBMxY","indicator":"Carousel_indicator__FAdDA"};